<div class="w-full h-full flex flex-col divide-y divide-white overflow-y-scroll snap-y snap-proximity">
	@for (day of logByDay; track day.uuid + $index) {
		<div class="snap-start w-full h-6 flex-none font-decimaBold uppercase text-xs leading-none flex items-center px-2 text-white bg-white/10">
			{{ day.date | date: 'dd/MM EEE' }}
		</div>
		@for (row of day.data; track row.uuid + 'log') {
			<app-table-row-wrapper [id]="row.uuid" [row]="row"></app-table-row-wrapper>
		}
	}
</div>